export default {
    map_standardColor: "Стандартный цвет",
    map_blue: "Тёмно-синий",
    map_cyan: "Индиго",
    map_gray: "Серый",
    map_black: "Чёрный",
    map_silver: "Серебристый",

    map_contacts: "Контакт",
    map_contactsPhone: "Телефон контакта",
    map_NameOfPlace: "Название объекта",
    map_latitude: "Широта",
    map_longitude: "Долгота",
    map_siteBasicTitle: "Основная информация об объекте",
    map_deviceListTitle: "Список устройств",
    map_deviceNum: "Код устройства",
    map_deviceModelNum: "Модель устройства",
    map_mapStyle: "Изменение стиля карты",
    map_goBacSitekNews: "Вернуться к информации об объекте",
    map_messageSite: "Сначала выберите объект!",
    map_siteEntity: "Организация",
    map_unit: "Здание",
    map_pushTitle: "История уведомлений",
    map_alarmHandle: "Обработка тревоги",

    map_state: "Статус",

    map_select: "Выбрано",

    map_placePoint: "Разместить точку",
    map_restPoint: "Сбросить точку",
    map_confirmEditPoint: "Подтвердить изменение точки",
    map_palceTIpes: "Нажмите на план, разместите и сохраните точку",
    map_firemAlarmSystem: "Карта",
    clear: "Очистить",
}
